// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enterPersonalDetailsComponent {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  position: relative;
}

/* .genderSelect {
  background-color: #1a1a1a;
  width: 31.51vw;
  height: 48px;
  border: 'none';
  outline: none;
} */
 .genderContainer{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
 }
.genderSelect {
    appearance: auto;        /* ✅ Keeps the dropdown arrow */
    -webkit-appearance: auto; /* For Safari */
    -moz-appearance: auto;    /* For Firefox */
  
    background-color: #1a1a1a;
    width: 31.51vw;
    height: 52px;
    border: none;             /* ✅ Removes default border */
    padding: 10px;
    border-radius: 52px;
    color: #7A7A7A;
    font-size: 14px;
    cursor: pointer;
  }
  .genderSelect:focus,
  .genderSelect:active {
    border: none;
    outline: none;
    background-color: #1a1a1a; /* Optional: keep background consistent */
    color: #7A7A7A; /* Optional: selected text color */
  }

.dateContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* .inputContainerWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
} */

.languageContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
  
  .languageSelect {
    background-color: #1a1a1a;
    width: 31.51vw;
    height: 5vh;
    border: none;
    padding: 0px 16px;
    border-radius: 52px;
    color: #7A7A7A;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
  }
  
  .selectedTags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .tag {
    background-color: #3a3a3a;
    border-radius: 25px;
    padding: 4px 10px;
    color: white;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  
  .removeIcon {
    margin-left: 6px;
    cursor: pointer;
    background-color: #D14848;
    border-radius: 50px;
    color: white;
    font-size: 12px;
  }
  
  .arrowIcon {
    font-size: 12px;
    color: #7a7a7a;
  }
  
  .dropdownMenu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 31.51vw;
    background-color: #1a1a1a;
    border-radius: 10px;
    box-shadow: 0 0 5px rgba(0,0,0,0.2);
    list-style: none;
    padding: 10px;
    margin-top: 4px;
    z-index: 10000000000;
    height: auto;
    max-height: 40vh;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #666 #1a1a1a;
  }
  
  .dropdownMenu li {
    padding: 10px;
    color: white;
    cursor: pointer;
    border-radius: 8px;
    width: 100%;
    font-size: 16px;
  }
  
  .dropdownMenu li:hover {
    background-color: #666;
  }

  @media (max-width: 1640px) {
    .languageContainer {
      gap: 10px;
    }
    .tag {
      border-radius: 25px;
      padding: 3px 8px;
      font-size: 10px;
    }
    .removeIcon {
      margin-left: 4px;
      border-radius: 50%;
      font-size: 10px;
    }
    .dropdownMenu li {
      padding: 8px;
      font-size: 14px;
    }
  }
  @media (max-width: 1440px) {
    .languageContainer {
      gap: 8px;
    }
    .tag {  
      border-radius: 25px;
      padding: 3px 8px;
      font-size: 10px;
    }
    .removeIcon {
      margin-left: 4px;
      border-radius: 50%;
      font-size: 10px;
    }
    .dropdownMenu li {
      padding: 6px;
      font-size: 12px;
      border-radius: 7px;
    }
  }
  @media (max-width: 1280px) {
    .languageContainer {
      gap: 6px;
    }
    .tag {
      border-radius: 25px;
      padding: 2px 6px;
      font-size: 8px;
    }
    .removeIcon {
      margin-left: 2px;
      border-radius: 50%;
      font-size: 6px;
    }
    .dropdownMenu li {
      padding: 5px;
      font-size: 10px;
      border-radius: 5px;
    }
  }
  @media (max-width: 1024px) {
    .languageContainer {
      gap: 4px;
    }
    .tag {
      border-radius: 25px;
      padding: 1px 4px;
      font-size: 6px;
    }
    .removeIcon {
      margin-left: 1px;
      border-radius: 50%;
      font-size: 6px;
    }
    .dropdownMenu li {
      padding: 1.5px;
      font-size: 8px;
      border-radius: 3px;
    }
  }

/* Mobile Responsive Styles - Only for small devices */
@media (max-width: 768px) {
  .enterPersonalDetailsComponent {
    gap: 16px;
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
  }

  .signInText {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
  }

  .rectangleBoxContainer {
    margin-bottom: 8px;
  }

  .languageContainer {
    width: 100%;
    gap: 8px;
  }

  .languageSelect {
    width: 100% !important;
    height: 48px;
    border-radius: 12px;
    padding: 0 16px;
    font-size: 16px;
    min-height: 48px;
  }

  .selectedTags {
    gap: 6px;
    flex-wrap: wrap;
  }

  .tag {
    background-color: #3a3a3a;
    border-radius: 20px;
    padding: 6px 12px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin: 2px 0;
  }

  .removeIcon {
    margin-left: 8px;
    cursor: pointer;
    background-color: #D14848;
    border-radius: 50%;
    color: white;
    font-size: 14px;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrowIcon {
    font-size: 16px;
    color: #7a7a7a;
    flex-shrink: 0;
  }

  .dropdownMenu {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100% !important;
    background-color: #1a1a1a;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    list-style: none;
    padding: 12px;
    margin-top: 6px;
    z-index: 1000;
    height: auto;
    max-height: 50vh;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #333;
  }

  .dropdownMenu li {
    padding: 12px 16px;
    color: white;
    cursor: pointer;
    border-radius: 8px;
    width: 100%;
    font-size: 16px;
    transition: background-color 0.2s ease;
    margin-bottom: 4px;
  }

  .dropdownMenu li:hover {
    background-color: #333;
  }

  .dropdownMenu li:last-child {
    margin-bottom: 0;
  }

  .dateContainer {
    width: 100%;
    gap: 8px;
  }

  .generalInputContainer {
    width: 100%;
    gap: 8px;
  }

  .labelText {
    font-size: 16px;
    font-weight: 500;
    color: white;
    margin-bottom: 4px;
  }

  .errorTooltip {
    font-size: 14px;
    color: #C15F5F;
    margin-top: 6px;
    padding: 0 4px;
  }
}

@media (max-width: 480px) {
  .enterPersonalDetailsComponent {
    gap: 14px;
    padding: 0 16px;
  }

  .signInText {
    font-size: 22px;
    line-height: 28px;
  }

  .languageSelect {
    height: 44px;
    border-radius: 10px;
    padding: 0 14px;
    font-size: 15px;
  }

  .tag {
    border-radius: 18px;
    padding: 5px 10px;
    font-size: 13px;
  }

  .removeIcon {
    margin-left: 6px;
    font-size: 12px;
  }

  .arrowIcon {
    font-size: 14px;
  }

  .dropdownMenu {
    border-radius: 10px;
    padding: 10px;
  }

  .dropdownMenu li {
    padding: 10px 14px;
    font-size: 15px;
    border-radius: 6px;
  }

  .labelText {
    font-size: 15px;
  }

  .errorTooltip {
    font-size: 13px;
  }
}

@media (max-width: 360px) {
  .enterPersonalDetailsComponent {
    gap: 12px;
    padding: 0 12px;
  }

  .signInText {
    font-size: 20px;
    line-height: 26px;
  }

  .languageSelect {
    height: 40px;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 14px;
  }

  .tag {
    border-radius: 16px;
    padding: 4px 8px;
    font-size: 12px;
  }

  .removeIcon {
    margin-left: 4px;
    font-size: 10px;
  }

  .arrowIcon {
    font-size: 12px;
  }

  .dropdownMenu {
    border-radius: 8px;
    padding: 8px;
  }

  .dropdownMenu li {
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 4px;
  }

  .labelText {
    font-size: 14px;
  }

  .errorTooltip {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EnterPersonalDetails/EnterPersonalDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;;;;GAMG;CACF;IACG,aAAa;IACb,sBAAsB;IACtB,uBAAuB;CAC1B;AACD;IACI,gBAAgB,SAAS,+BAA+B;IACxD,wBAAwB,EAAE,eAAe;IACzC,qBAAqB,KAAK,gBAAgB;;IAE1C,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,YAAY,cAAc,6BAA6B;IACvD,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;EACA;;IAEE,YAAY;IACZ,aAAa;IACb,yBAAyB,EAAE,yCAAyC;IACpE,cAAc,EAAE,kCAAkC;EACpD;;AAEF;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;GAIG;;AAEH;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;EAEE;IACE,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE;MACE,SAAS;IACX;IACA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;IACjB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,YAAY;MACZ,eAAe;IACjB;EACF;EACA;IACE;MACE,QAAQ;IACV;IACA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,eAAe;IACjB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,eAAe;IACjB;IACA;MACE,YAAY;MACZ,eAAe;MACf,kBAAkB;IACpB;EACF;EACA;IACE;MACE,QAAQ;IACV;IACA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,cAAc;IAChB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;IAChB;IACA;MACE,YAAY;MACZ,eAAe;MACf,kBAAkB;IACpB;EACF;EACA;IACE;MACE,QAAQ;IACV;IACA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,cAAc;IAChB;IACA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;IAChB;IACA;MACE,cAAc;MACd,cAAc;MACd,kBAAkB;IACpB;EACF;;AAEF,sDAAsD;AACtD;EACE;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".enterPersonalDetailsComponent {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 20px;\n  position: relative;\n}\n\n/* .genderSelect {\n  background-color: #1a1a1a;\n  width: 31.51vw;\n  height: 48px;\n  border: 'none';\n  outline: none;\n} */\n .genderContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n }\n.genderSelect {\n    appearance: auto;        /* ✅ Keeps the dropdown arrow */\n    -webkit-appearance: auto; /* For Safari */\n    -moz-appearance: auto;    /* For Firefox */\n  \n    background-color: #1a1a1a;\n    width: 31.51vw;\n    height: 52px;\n    border: none;             /* ✅ Removes default border */\n    padding: 10px;\n    border-radius: 52px;\n    color: #7A7A7A;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  .genderSelect:focus,\n  .genderSelect:active {\n    border: none;\n    outline: none;\n    background-color: #1a1a1a; /* Optional: keep background consistent */\n    color: #7A7A7A; /* Optional: selected text color */\n  }\n\n.dateContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* .inputContainerWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n} */\n\n.languageContainer {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n  \n  .languageSelect {\n    background-color: #1a1a1a;\n    width: 31.51vw;\n    height: 5vh;\n    border: none;\n    padding: 0px 16px;\n    border-radius: 52px;\n    color: #7A7A7A;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    cursor: pointer;\n    box-sizing: border-box;\n  }\n  \n  .selectedTags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .tag {\n    background-color: #3a3a3a;\n    border-radius: 25px;\n    padding: 4px 10px;\n    color: white;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n  }\n  \n  .removeIcon {\n    margin-left: 6px;\n    cursor: pointer;\n    background-color: #D14848;\n    border-radius: 50px;\n    color: white;\n    font-size: 12px;\n  }\n  \n  .arrowIcon {\n    font-size: 12px;\n    color: #7a7a7a;\n  }\n  \n  .dropdownMenu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 31.51vw;\n    background-color: #1a1a1a;\n    border-radius: 10px;\n    box-shadow: 0 0 5px rgba(0,0,0,0.2);\n    list-style: none;\n    padding: 10px;\n    margin-top: 4px;\n    z-index: 10000000000;\n    height: auto;\n    max-height: 40vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: #666 #1a1a1a;\n  }\n  \n  .dropdownMenu li {\n    padding: 10px;\n    color: white;\n    cursor: pointer;\n    border-radius: 8px;\n    width: 100%;\n    font-size: 16px;\n  }\n  \n  .dropdownMenu li:hover {\n    background-color: #666;\n  }\n\n  @media (max-width: 1640px) {\n    .languageContainer {\n      gap: 10px;\n    }\n    .tag {\n      border-radius: 25px;\n      padding: 3px 8px;\n      font-size: 10px;\n    }\n    .removeIcon {\n      margin-left: 4px;\n      border-radius: 50%;\n      font-size: 10px;\n    }\n    .dropdownMenu li {\n      padding: 8px;\n      font-size: 14px;\n    }\n  }\n  @media (max-width: 1440px) {\n    .languageContainer {\n      gap: 8px;\n    }\n    .tag {  \n      border-radius: 25px;\n      padding: 3px 8px;\n      font-size: 10px;\n    }\n    .removeIcon {\n      margin-left: 4px;\n      border-radius: 50%;\n      font-size: 10px;\n    }\n    .dropdownMenu li {\n      padding: 6px;\n      font-size: 12px;\n      border-radius: 7px;\n    }\n  }\n  @media (max-width: 1280px) {\n    .languageContainer {\n      gap: 6px;\n    }\n    .tag {\n      border-radius: 25px;\n      padding: 2px 6px;\n      font-size: 8px;\n    }\n    .removeIcon {\n      margin-left: 2px;\n      border-radius: 50%;\n      font-size: 6px;\n    }\n    .dropdownMenu li {\n      padding: 5px;\n      font-size: 10px;\n      border-radius: 5px;\n    }\n  }\n  @media (max-width: 1024px) {\n    .languageContainer {\n      gap: 4px;\n    }\n    .tag {\n      border-radius: 25px;\n      padding: 1px 4px;\n      font-size: 6px;\n    }\n    .removeIcon {\n      margin-left: 1px;\n      border-radius: 50%;\n      font-size: 6px;\n    }\n    .dropdownMenu li {\n      padding: 1.5px;\n      font-size: 8px;\n      border-radius: 3px;\n    }\n  }\n\n/* Mobile Responsive Styles - Only for small devices */\n@media (max-width: 768px) {\n  .enterPersonalDetailsComponent {\n    gap: 16px;\n    padding: 0 20px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .signInText {\n    font-size: 24px;\n    line-height: 32px;\n    margin-bottom: 8px;\n  }\n\n  .rectangleBoxContainer {\n    margin-bottom: 8px;\n  }\n\n  .languageContainer {\n    width: 100%;\n    gap: 8px;\n  }\n\n  .languageSelect {\n    width: 100% !important;\n    height: 48px;\n    border-radius: 12px;\n    padding: 0 16px;\n    font-size: 16px;\n    min-height: 48px;\n  }\n\n  .selectedTags {\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  .tag {\n    background-color: #3a3a3a;\n    border-radius: 20px;\n    padding: 6px 12px;\n    color: white;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    margin: 2px 0;\n  }\n\n  .removeIcon {\n    margin-left: 8px;\n    cursor: pointer;\n    background-color: #D14848;\n    border-radius: 50%;\n    color: white;\n    font-size: 14px;\n    padding: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .arrowIcon {\n    font-size: 16px;\n    color: #7a7a7a;\n    flex-shrink: 0;\n  }\n\n  .dropdownMenu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100% !important;\n    background-color: #1a1a1a;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3);\n    list-style: none;\n    padding: 12px;\n    margin-top: 6px;\n    z-index: 1000;\n    height: auto;\n    max-height: 50vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    border: 1px solid #333;\n  }\n\n  .dropdownMenu li {\n    padding: 12px 16px;\n    color: white;\n    cursor: pointer;\n    border-radius: 8px;\n    width: 100%;\n    font-size: 16px;\n    transition: background-color 0.2s ease;\n    margin-bottom: 4px;\n  }\n\n  .dropdownMenu li:hover {\n    background-color: #333;\n  }\n\n  .dropdownMenu li:last-child {\n    margin-bottom: 0;\n  }\n\n  .dateContainer {\n    width: 100%;\n    gap: 8px;\n  }\n\n  .generalInputContainer {\n    width: 100%;\n    gap: 8px;\n  }\n\n  .labelText {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    margin-bottom: 4px;\n  }\n\n  .errorTooltip {\n    font-size: 14px;\n    color: #C15F5F;\n    margin-top: 6px;\n    padding: 0 4px;\n  }\n}\n\n@media (max-width: 480px) {\n  .enterPersonalDetailsComponent {\n    gap: 14px;\n    padding: 0 16px;\n  }\n\n  .signInText {\n    font-size: 22px;\n    line-height: 28px;\n  }\n\n  .languageSelect {\n    height: 44px;\n    border-radius: 10px;\n    padding: 0 14px;\n    font-size: 15px;\n  }\n\n  .tag {\n    border-radius: 18px;\n    padding: 5px 10px;\n    font-size: 13px;\n  }\n\n  .removeIcon {\n    margin-left: 6px;\n    font-size: 12px;\n  }\n\n  .arrowIcon {\n    font-size: 14px;\n  }\n\n  .dropdownMenu {\n    border-radius: 10px;\n    padding: 10px;\n  }\n\n  .dropdownMenu li {\n    padding: 10px 14px;\n    font-size: 15px;\n    border-radius: 6px;\n  }\n\n  .labelText {\n    font-size: 15px;\n  }\n\n  .errorTooltip {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 360px) {\n  .enterPersonalDetailsComponent {\n    gap: 12px;\n    padding: 0 12px;\n  }\n\n  .signInText {\n    font-size: 20px;\n    line-height: 26px;\n  }\n\n  .languageSelect {\n    height: 40px;\n    border-radius: 8px;\n    padding: 0 12px;\n    font-size: 14px;\n  }\n\n  .tag {\n    border-radius: 16px;\n    padding: 4px 8px;\n    font-size: 12px;\n  }\n\n  .removeIcon {\n    margin-left: 4px;\n    font-size: 10px;\n  }\n\n  .arrowIcon {\n    font-size: 12px;\n  }\n\n  .dropdownMenu {\n    border-radius: 8px;\n    padding: 8px;\n  }\n\n  .dropdownMenu li {\n    padding: 8px 12px;\n    font-size: 14px;\n    border-radius: 4px;\n  }\n\n  .labelText {\n    font-size: 14px;\n  }\n\n  .errorTooltip {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
